"use client";

import { CapabilityPage } from "@/components/sections/page-composer";
import { codeExamplesData } from "@/lib/data/developers-code-examples";

export function CodeExamplesPage() {
  return <CapabilityPage data={codeExamplesData} />;
}
